import { connect } from 'react-redux'
import * as actions from '../../actions/auth'
import Auth from '../../components/layout/Auth'

const mapStateToProps = ({ auth }) => ({
  token: auth.token,
  auth,
})

const mapDispatchToProps = dispatch => ({
  willMount: history => dispatch(actions.sso(history)),
  signOut: history => dispatch(actions.signOut(history)),
  signIn: (values, history) => dispatch(actions.auth(values, history)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Auth)
